import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  DELETE_ITEM,
  EDIT_ITEM,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SAVE_REQUEST,
  SAVE_SUCCESS,
  SEARCH
} from './rewards-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const getAllRequest = () => {
  return {
    type: GET_ALL_REQUEST
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveRequest = (id: any, payload: any, files?: any) => {
  return {
    type: SAVE_REQUEST,
    id,
    payload,
    files
  };
};

export const saveSuccess = async () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const deleteItem = (id: string) => {
  return {
    type: DELETE_ITEM,
    id
  };
};

export const editItem = (id: string) => {
  return {
    type: EDIT_ITEM,
    id
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: String) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryText?: String) => {
  return {
    type: SEARCH,
    queryText
  };
};
